/** Ponto único de import da camada de dados: `import { api } from '@/api'`. */
export * from './types'
export { USE_MOCKS, TURNSTILE_SITE_KEY } from './config'
export { tokenStorage } from './client'

import * as admin from './services/admin'
import * as auth from './services/auth'
import * as catalog from './services/catalog'
import * as purchases from './services/purchases'

export const api = { admin, auth, catalog, purchases }
